
<template>
  <section class="section">
    <div class="columns">
      <div class="column container is-8 main">
        <content-filter v-on:searchClick="searchHandler" :createNewItem="createProduct" :filterGroups="filterGroups" :infoMsg="filterMsg"></content-filter>

        <!-- search results header -->
        <nav v-if="searchingText.length > 0" class="level-left">
          <div class="level-item">
            <p class="subtitle is-4">
              <span>Search results for: {{ searchingText}}</span>
            </p>
          </div>
          <b-tooltip class="level-item" label="Clear search results">
            <button class="delete" v-on:click="clearSearch">Clear</button>
          </b-tooltip>
        </nav>
        <br>

        <div v-for="(item, index) in groups" :key="index">
          <product-card :product="item" v-on:edit="editProduct" v-on:delete="deleteGroupModal" v-on:file="saveFileModal" :action1="'edit'" :action2="'delete'" :action3="'file'" />
          <br>
        </div>

        <pagination class="is-centered" :urlBuilder="urlBuilder"
                    v-bind:currentPage="page.pageNumber"
                    v-bind:lastPage="page.totalPages" />

        <loading :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="false"></loading>
      </div>

      <!--END CONTENT -->
      <product-editor v-if="isEditorVisible" v-on:closeProductEditor="closeProductEditor"
                      :groupId="this.groupId" :header="productEditorHeader" />
      <delete-confirmer v-if="isDeleteModalVisible" :text="deleteMsg" :header="deleteHeader"
                        v-on:close="closeProductDeleteWindow" :id="this.groupId" v-on:delete="deleteGroup" />
      <changes-saver v-if="isSaverVisible" v-on:closeSaveChangesWindow="closeFileSaver"
                             :groupId="this.groupId" :filterType="filterType"/>

    </div>
  </section>
</template>

<script>
  import ProductCard from "../ProductsGroupCard";
  import ContentFilter from "../ContentFilter";
  import AppBreadcrumb from "../AppBreadcrumb";
  import ProductEditor from "../ProductsGroupEditor";
  import DeleteConfirmer from "../DeleteConfirmer";
  import ChangesSaver from "../CombinedChangesSaver";
  import Pagination from "vue-bulma-pagination/src/Pagination";

  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.min.css";

  //import this.HTTP from "../Http";

  export default {
    name: "product-groups-vue",
    components: {
      ProductCard,
      AppBreadcrumb,
      ContentFilter,
      ProductEditor,
      DeleteConfirmer,
      ChangesSaver,
      Pagination,
      Loading
    },
    data() {
      return {
        groups: [],
        isEditorVisible: false,
        isDeleteModalVisible: false,
        isSaverVisible: false,
        deleteHeader: "Are you sure that you want to delete this group?",
        deleteMsg: "This group will be lost forever",
        groupId: -1,
        productEditorHeader: "",
        filterType: "All",
        filterGroups: [],

        //pagination
        page: {
          pageNumber: 1,
          totalPages: 13,
          pageSize: 10,
          totalItems: -1
        },

        searchingText: "",
        loading: false
      };
    },
    computed: {
      filterMsg: function () {
        if (this.page.totalItems > 0)
          return "<strong>" + this.page.totalItems + "</strong> groups";
        else return "";
      }
    },
    methods: {
      getGroups() {
        this.loading = true;
        let query = "productGroups/";
        if (this.searchingText.length > 0) {
          query += "search/";
        }
        query += this.page.pageNumber + "/" + this.page.pageSize + "/";
        if (
          this.searchingText !== null &&
          this.searchingText !== undefined &&
          this.searchingText.length > 0
        ) {
          query += this.searchingText;
        }

        this.HTTP.get(query)
          .then(response => {
            this.groups = response.data.entities;
            this.page = response.data.page;
            this.loading = false;
          })
          .catch(e => {
            console.log(e);
          });
      },
      createProduct() {
        this.isEditorVisible = true;
        this.groupId = -1; //shouldn't edit
        this.productEditorHeader = "Add new product group";
      },
      editProduct(id) {
        this.isEditorVisible = true;
        this.groupId = id;
        this.productEditorHeader = "Edit product group";
      },
      deleteGroupModal(id) {
        this.isDeleteModalVisible = true;
        this.groupId = id;
      },
      saveFileModal(id) {
        this.isSaverVisible = true;
        this.groupId = id;
      },
      deleteGroup() {
        this.HTTP.delete(`productGroups/` + this.groupId)
          .then(response => {
            this.closeProductDeleteWindow();
          })
          .catch(e => {
            console.log(e);
          });
      },
      closeProductEditor() {
        this.isEditorVisible = false;
        this.getGroups(); //should be optimized!
      },
      closeProductDeleteWindow() {
        this.isDeleteModalVisible = false;
        this.getGroups(); //should be optimized!
      },
      closeFileSaver() {
        this.isSaverVisible = false;
      },
      //pagination

      urlBuilder(page) {
        return { query: { ...this.$route.query, page } }; // Changing page in location query
      },
      searchHandler(searchingText) {
        this.searchingText = searchingText;
      },

      clearSearch() {
        this.searchingText = "";
        this.page.pageNumber = 1;
      },

      pushUrl() {
        this.$router.push({
          path: "ProductGroups",
          query: {
            page: this.page.pageNumber,
            search: this.searchingText
          }
        });
      }
    },
    created() {
      console.log("I HAVE BEEN CREATED")
      if (this.cardsCount) {
        this.page.pageSize = this.cardsCount;
      }
      this.HTTP.load(); //.then(() => {
      this.getGroups();
      // });
    },

    watch: {
      $route(to, from) {
        if (to.query.page != null && to.query.page != undefined) {
          this.page.pageNumber = parseInt(to.query.page);
          this.searchingText = to.query.search;
        } else {
          //this.pushUrl();
        }

        this.getGroups();
      },
      searchingText: function (val) {
        this.pushUrl();
      },
      page: function (val) {
        this.pushUrl();
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/views/ProductGroups.Vue